module.exports = __webpack_public_path__ + "static/img/moreinfor.fc284d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moreinfor.png
// module id = /IaA
// module chunks = 29